import React from 'react';
import { CheckboxField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { capitalizeFirstLetter } from 'formatters';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { CardSkeleton } from './CardSkeleton';
import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const DealStage = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading, error } = useFilterOptions(VOFilterType.STAGE);

  return (
    <RenderWithFallback isLoading={loading && !options.length} error={error} fallBack={<CardSkeleton />}>
      {options.map(({ label, value }) => (
        <CheckboxField key={value} control={control} name={`STAGE.${value}`} label={capitalizeFirstLetter(label)} />
      ))}
    </RenderWithFallback>
  );
};
